import { v4 as uuid } from 'uuid';
const theme = JSON.parse(localStorage.getItem('theme'));

export const styleHelper = () => {
  return {
    padding: padding,
    paddingResponsive: paddingResponsive,
    margin: margin,
    marginResponsive: marginResponsive,
    bgColor: 'transparent',
    text: text,
    textResponsive: textResponsive,
    border: border,
    rounded: rounded,
    hover: hover,
    animation: animation,
    alignment: alignment,
    orientation: orientation,
    width,
    height,
    visibility,
    initColumn
  };
};


const initColumn = (colWidth = 0) => {
  return {
    id: uuid(),
    style: {
      width: { base: colWidth },
      padding: paddingResponsive(),
      // padding: styleHelper().padding(),
      rounded: rounded(0, 0, 0, 0),
      boxShadow: "none",
      bgColor: '#ffffff',
      hover: hover(),
      animation: animation(),
      bgImage: {
        path: '',
        altText: '',
        id: ''
      },
      border: styleHelper().border(0, 'solid', '#3F3047'),
    },
    children: []
  }
}

const padding = (top = 0, right = 0, bottom = 0, left = 0) => {
  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
  };
};

const paddingResponsive = (top = 0, right = 0, bottom = 0, left = 0) => {
  return {
    top: { base: top },
    right: { base: right },
    bottom: { base: bottom, },
    left: { base: left },
  };
};

const margin = (top = 0, right = 0, bottom = 0, left = 0) => {
  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
  };
};

const marginResponsive = (top = 0, right = 0, bottom = 0, left = 0) => {
  return {
    top: { base: top },
    right: { base: right },
    bottom: { base: bottom },
    left: { base: left },
  };
};

const textResponsive = (
  size = { base: '16' },
  weight = '400',
  color = '#212121',
  align = { base: 'left' },
  transform = 'none',
  lineHeight = 1.5,
  letterSpacing = 0,
  fontFamily = theme?.font ?? '',
  fontStyle = 'normal',
  textDecoration = 'none'
) => {
  return {
    size: size,
    color: color,
    weight: weight,
    align: align,
    transform: transform,
    lineHeight: lineHeight,
    letterSpacing: letterSpacing,
    fontFamily: fontFamily,
    fontStyle: fontStyle,
    textDecoration: textDecoration,
  };
};

const text = (
  size = 16,
  weight = '400',
  color = '#212121',
  align = 'left',
  transform = 'none',
  lineHeight = 1.5,
  letterSpacing = 0,
  fontFamily = theme?.font ?? '',
  fontStyle = 'normal',
  textDecoration = 'none'
) => {
  return {
    size: size,
    color: color,
    weight: weight,
    align: align,
    transform: transform,
    lineHeight: lineHeight,
    letterSpacing: letterSpacing,
    fontFamily: fontFamily,
    fontStyle: fontStyle,
    textDecoration: textDecoration,
  };
};

const border = (width = 1, style = 'solid', color = '#666666') => {
  return {
    top: width,
    right: width,
    bottom: width,
    left: width,
    color: color,
    style: style,
  };
};

const rounded = (
  topLeft = 4,
  topRight = 4,
  bottomRight = 4,
  bottomLeft = 4
) => {
  return {
    topLeft: topLeft,
    topRight: topRight,
    bottomLeft: bottomLeft,
    bottomRight: bottomRight,
  };
};

const hover = (color = '#212121') => {
  return {
    backgroundColor: 'transparent',
    color: color,
    transformValue: 'none',
    transform: {
      scaleX: 1,
      scaleY: 1,
      skewX: 0,
      skewY: 0,
      rotateX: 0,
      rotateY: 0,
      rotateZ: 0,
      translateX: 0,
      translateY: 0,
    },
  };
};

const animation = () => {
  return {
    animation: false,
    value: 'fadeIn',
    onScroll: false,
    isRepeat: false,
    transition: {
      type: 'spring',
      duration: 0.5,
      delay: 0,
      bounce: 0.4,
      repeat: 1,
      repeatType: 'mirror',
      repeatDelay: 0,
    },
  };
};

const alignment = (data, side = 'left') => {
  const align = side === 'left' ? 'flex-start' : 'flex-end';
  return {
    base: data == 'flex' ? align : 'left',
  };
};

const orientation = (data) => {
  return {
    base: data == 'vertical' ? 'vertical' : 'horizontal',
    md: data == 'vertical' ? 'vertical' : 'horizontal',
    lg: data == 'vertical' ? 'vertical' : 'horizontal',
  };
};


const width = (width = '100%') => {
  return {
    base: width
  };
};


const height = (height = 'auto') => {
  return {
    base: height
  };
};


const visibility = (visibility = 'block') => {
  return {
    base: visibility
  }
}